import React from 'react'


function Navigation(){

    return(
        <React.Fragment>
        <nav>
            <img src="/github-mark-white.png" width="50" height="50" />
        </nav>
        </React.Fragment>
    )
}

export default Navigation